"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ExternalResourceTypes = [
    'affiliation',
    'credential',
    'eligibility',
    'event',
    'membership',
    'organization',
    'profile',
    'registration',
    'registrationResult',
    'team',
];
